// extracted by mini-css-extract-plugin
module.exports = {"ApplyProcessDetails":"index-module_ApplyProcessDetails_3nrYw","fixedNoticeBar":"index-module_fixedNoticeBar_1yS5T"};